import { queryOptions, useQuery } from '@tanstack/react-query';
// Default import: Next 16.3 Turbopack drops named aliases of a defaulted server action in the client graph
import getSubjects from '@/app/(teacher)/profile/_actions/getSubjects';
import type { Subject } from '@/app/(teacher)/profile/_actions/types';
import type { ServerActionResponse } from '@/features/server/actions/types';

export const SubjectsQuery = queryOptions({
  queryKey: ['subjects'],
  queryFn: getSubjects,
  select: (resp: ServerActionResponse<Subject[]>) => resp.data,
});

export default function useSubjects() {
  return useQuery(SubjectsQuery);
}
